import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchFirstMessagesPending = createAction(constants.FETCH_FIRST_MESSAGES_PENDING)
export const fetchFirstMessagesFailed = createAction(constants.FETCH_FIRST_MESSAGES_FAILED)
export const receiveFirstMessages = createAction(constants.RECEIVE_FIRST_MESSAGES)


export const fetchConversationMessages = createAction(constants.FETCH_CONVERSATION_MESSAGES)
export const fetchPaginatedConversationMessagesPending = createAction(constants.FETCH_PAGINATED_CONVERRSATION_MESSAGES_PENDING)
export const fetchPaginatedConversationMessagesFailed = createAction(constants.FETCH_PAGINATED_CONVERRSATION_MESSAGES_FAILED)
export const fetchPaginatedConversationMessagesCancelled = createAction(constants.FETCH_PAGINATED_CONVERRSATION_MESSAGES_CANCELLED)
export const receivePaginatedMessageList = createAction(constants.RECEIVE_PAGINATED_MESSAGE_LIST)

export const fetchNextPaginatedConversationMessages = createAction(constants.FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES)
export const fetchNextPaginatedConversationMessagesPending = createAction(constants.FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_PENDING)
export const fetchNextPaginatedConversationMessagesFailed = createAction(constants.FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_FAILED)
export const fetchNextPaginatedConversationMessagesCancelled = createAction(constants.FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_CANCELLED)
export const receiveNextMessageList = createAction(constants.RECEIVE_NEXT_MESSAGE_LIST)

export const createMessage = createAction(constants.CREATE_MESSAGE)
export const createMessagePending = createAction(constants.CREATE_MESSAGE_PENDING)
export const createMessageFailed = createAction(constants.CREATE_MESSAGE_FAILED)
export const receiveMessage = createAction(constants.RECEIVE_MESSAGE)

export const removeMessage = createAction(constants.REMOVE_MESSAGE)

export const messageRead = createAction(constants.MESSAGE_READ)
export const messageReadPending = createAction(constants.MESSAGE_READ_PENDING)
export const messageReadFailed = createAction(constants.MESSAGE_READ_FAILED)
export const messageReadSuccess = createAction(constants.MESSAGE_READ_SUCCESS) // dummy
export const optimisticMessageReadSuccess = createAction(constants.OPTIMISTIC_MESSAGE_READ_SUCCESS)
export const markMessageReadByConversation = createAction(constants.MARK_MESSAGE_READ_BY_CONVERSATION)
export const bulkMessageReadSuccess = createAction(constants.BULK_MESSAGE_READ_SUCCESS)

export const messageReadUntilFailed = createAction(constants.MESSAGE_READ_UNTIL_FAILED)
export const messageReadUntilSuccess = createAction(constants.MESSAGE_READ_UNTIL_SUCCESS)

export const receiveMessageRead = createAction(constants.RECEIVE_MESSAGE_READ)

export const notifyUser = createAction(constants.NOTIFY_USER)
export const browserNotification = createAction(constants.BROWSER_NOTIFICATION)

export const selectBotAction = createAction(constants.SELECT_BOT_ACTION)
export const fetchPlaybookContext = createAction(constants.FETCH_PLAYBOOK_CONTEXT)

export const loadMoreMessages = createAction(constants.LOAD_MORE_MESSAGES)

export const receiveBulkUpdateMessages = createAction(constants.RECEIVE_BULK_UPDATE_MESSAGES)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/message/actions.js